import UrbanProcessesIcon from './component'

export default UrbanProcessesIcon
